import React from "react";

export default function TimeInput(props) {
  const [value, setValue] = React.useState(props.value);

  const input = React.useRef();

  const onChange = (event) => {
    if(!props.disabled){
      setValue(event.target.value);
    }
  };

  const onBlur = (event) => {
    const value = event.target.value;
    const seconds = Math.max(0, getSecondsFromHHMMSS(value));
    const time = toHHMMSS(seconds);

    //if (value == "99:99:99") {
    //  setValue("Infinity");
    //} else if (time == "0:00") {
    //  setValue("00:00:00");
    //} else {
      setValue(time);
    //}

    props.onChange(time);
  };

  const getSecondsFromHHMMSS = (value) => {
    const [str1, str2, str3] = value.split(":");

    const val1 = Number(str1);
    const val2 = Number(str2);
    const val3 = Number(str3);

    if (!isNaN(val1) && isNaN(val2) && isNaN(val3)) {
      return val1;
    }

    if (!isNaN(val1) && !isNaN(val2) && isNaN(val3)) {
      return val1 * 60 + val2;
    }

    if (!isNaN(val1) && !isNaN(val2) && !isNaN(val3)) {
      return val1 * 60 * 60 + val2 * 60 + val3;
    }

    return 0;
  };

  const toHHMMSS = (secs) => {
    const secNum = parseInt(secs.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const seconds = secNum % 60;

    return [hours, minutes, seconds]
      .map((val) => (val < 10 ? `0${val}` : val))
      //.filter((val, index) => val !== "00" || index > 0)
      .join(":")
      //.replace(/^0/, "");
  };

  return (
    <input
      disabled={props.disabled}
      type="text"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      ref={input}
      onKeyUp={(e) => {
        if (e.which === 13) input.current.blur();
      }}
    />
  );
}
